import ActionTypes from '@ziynx/action-types';
import { getActionGroup } from '@ziynx/components/utilities';

const initialState = {};

export default function reduceJobItems(
  state = initialState,
  action,
) {
  if (!action.type) {
    return state;
  }

  const actionGroup = getActionGroup(action?.type);

  const jobItem = state[action?.id] ?? {};

  switch (action.type) {
  case ActionTypes.jobItem.getJob.START:
    return {
      ...state,
      [action?.id]: {
        ...jobItem,
        fetching: true,
        error: null,
        success: false,
      },
    };
  case ActionTypes.jobItem.postJob.START:
    return {
      ...state,
      [actionGroup]: {
        ...action?.body ?? {},
        fetching: true,
        error: null,
        success: false,
      },
      [action?.id]: {
        ...jobItem,
        ...(action?.body ?? {}),
        fetching: false,
        success: true,
        error: null,
      },
    };

  case ActionTypes.jobItem.patchJob.START:
    return {
      ...state,
      [action?.id]: {
        ...jobItem,
        fetching: true,
        error: null,
        success: false,
        patching: true,
        patchSuccess: false,
      },
    };

  case ActionTypes.jobItem.postJob.SUCCESS:
    return {
      ...state,
      ...{
        [actionGroup]: {
          fetching: false,
          success: true,
          error: null,
        },
        [action?.id]: {
          ...jobItem,
          ...(action?.response ?? {}),
          fetching: false,
          success: true,
          error: null,
        },
      },
    };

  case ActionTypes.jobItem.getJob.SUCCESS:
    return {
      ...state,
      [action?.id]: {
        ...jobItem,
        ...(action?.response ?? {}),
        fetching: false,
        error: null,
        success: true,
      },
    };

  case ActionTypes.jobItem.patchJob.SUCCESS:
    return {
      ...state,
      [action?.id]: {
        ...jobItem,
        ...(action?.response ?? {}),
        fetching: false,
        success: true,
        error: null,
        patching: false,
        patchSuccess: true,
      },
    };

  case ActionTypes.jobItem.postJob.ERROR:
  case ActionTypes.jobItem.getJob.ERROR:
  case ActionTypes.jobItem.patchJob.ERROR:
    return {
      ...state,
      ...{
        [action?.id]: {
          ...jobItem,
          fetching: false,
          success: false,
          error: action?.error,
        },
      },
    };

  case ActionTypes.jobItem.clear:
    if (action.id) {
      return {
        ...state,
        [action?.id]: {
          ...jobItem,
          patchSuccess: false,
        },
      };
    }
    return {
      ...state,
      POST_JOB_API: {
        ...state.POST_JOB_API,
        success: false,
      },
    };
  default:
    return state;
  }
}
